/*jshint esversion: 8 */
//{/* use this to comment inside jsx*/}
import './styles/home.css';
import './styles/estate.css';
import Image from 'react-bootstrap/Image';
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import ab from './pix/mail.png';
import mp from './pix/arrow-right-1.png';
import l4 from './pix/l4.svg';
import estate from './pix/estate.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';


{/**logo should be png file, have a transparent background */}

function Estate () {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [aboutUsHover, setAboutUsHover] = useState(false);
    const [strategiesHover, setStrategiesHover] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.classList.toggle("menu-open", menuOpen);
        // Cleanup: make sure class is removed if the component unmounts
        // while the menu is open (e.g. route change).
        return () => {
            if (menuOpen) document.body.classList.remove("menu-open");
        };
    }, [menuOpen]);

    // Simple toggle for the hamburger button — no more manual DOM calls here.
    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    // Dedicated close function used by the X button, overlay, and nav items.
    const closeMenu = () => {
        setMenuOpen(false);
    };
    // Add these states for mobile dropdowns (separate from desktop)
    const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
    const [mobileStrategiesOpen, setMobileStrategiesOpen] = useState(false);
    // New State for Scroll Effect
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // If user scrolls more than 150px, trigger the fixed state
            if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
     <div class=''>

    <Navbar id='nav-ham' expanded={expanded} onToggle={() => setExpanded(!expanded)} collapseOnSelect expand="lg" fixed="top" className={`custom-navbar ${scrolled ? 'navbar-fixed-reveal' : ''}`} variant="light">
  <Container className="d-flex w-100 align-items-center justify-content-between" id='nav-con-f'>
  <Navbar.Brand href="/"><Image
                src={l4}
                id='nav-img-og'
                alt="shereen Logo"
            /></Navbar.Brand>

{/* Custom Hamburger Button for mobile */}
  <button
  id='burg'
  className={`hamburger-button ${menuOpen ? "active" : ""}`}
  onClick={toggleMenu}
  aria-label="Menu"
>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
</button>

  <Navbar.Collapse id="responsive-navbar-nav" style = {{}}>
    <Nav className="ms-auto align-items-center"  style = {{marginRight: '-10%'}}  >
    <NavDropdown
                    title={
                        <span  onMouseEnter={() => setAboutUsHover(true)} onClick={(e) => {e.preventDefault(); navigate('/abt')}}
                        onMouseLeave={() => setAboutUsHover(false)} className="custom-span">
                            About Us <FontAwesomeIcon icon={faChevronDown}  className="dropdown-arrow ms-2" style = {{fontSize: '18px'}}/>
                        </span>
                    }
                    id="aboutus-dropdown"
                    className="nav-dropdown-custom"
                    show={aboutUsHover}
                >
                    <NavDropdown.Item onClick={() => navigate('/corporate-governance')}>
                        Corporate Governance
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/chairmans-message')}>
                        Chairman's Message
                    </NavDropdown.Item>
                </NavDropdown>

      {/**SECOND NAV HOV */}
    <NavDropdown
    title={
        <span  onMouseEnter={() => setStrategiesHover(true)}
                onMouseLeave={() => setStrategiesHover(false)} className="custom-span">
            Our Strategies <FontAwesomeIcon icon={faChevronDown} style = {{fontSize: '18px'}} className="dropdown-arrow ms-2" />
        </span>
    }

    id="strategies-dropdown"
    className="nav-dropdown-custom"
    show={strategiesHover}
>
    <NavDropdown.Item onClick={() => navigate('/opportunities')}>
        Opportunistic Investing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/lending')}>
        Direct Lending
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/liquidity-solutions')}>
        Fund Liquidity Solutions
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/corporate-finance')}>
        Corporate Financing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/estate')}>
        Real Estate
    </NavDropdown.Item>
</NavDropdown>
      <Nav.Link id="nav-lks" onClick={() => navigate('/team')}>Our Team</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/careers')}>Careers</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/contact-us')}>Contact Us</Nav.Link>

    </Nav>

  </Navbar.Collapse>
  </Container>
</Navbar>

{/* ====================== CUSTOM MOBILE SLIDE MENU ====================== */}
{/* ====================== FULL SCREEN MOBILE SLIDE MENU ====================== */}
<div className={`mobile-menu-fullscreen ${menuOpen ? 'active' : ''}`}>
  <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}></div>
  <div className="mobile-menu-container">
    <button className="mobile-menu-close" onClick={() => setMenuOpen(false)}>×</button>

    <div className="mobile-menu-content">
      <Nav className="flex-column mobile-nav-stack">

        {/* About Us with Dropdown */}
<div className="mobile-dropdown-wrapper">
<div className="mobile-menu-item" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
  <span
    className="mobile-menu-text"
    onClick={() => { navigate('/abt'); setMenuOpen(false); }}
    style={{ flex: 1, cursor: 'pointer' }}
  >
    About Us
  </span>
  <span
    className={`dropdown-arrow ${mobileAboutOpen ? 'open' : ''}`}
    onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
    style={{ cursor: 'pointer', marginLeft:'20px'}}
  >
    ▼
  </span>
</div>
{mobileAboutOpen && (
  <div className="mobile-sub-menu">
    <div className="sub-item" onClick={() => { navigate('/corporate-governance'); setMenuOpen(false); }}>
      Corporate Governance
    </div>
    <div className="sub-item" onClick={() => { navigate('/chairmans-message'); setMenuOpen(false); }}>
      Chairman's Message
    </div>
  </div>
)}
</div>

        {/* Our Strategies with Dropdown */}
        <div className="mobile-dropdown-wrapper">
          <div
          className="mobile-menu-item"
          onClick={() => setMobileStrategiesOpen(!mobileStrategiesOpen)}
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <span style={{ flex: 1, cursor: 'pointer' }}>
            Our Strategies
          </span>
          <span className={`dropdown-arrow ${mobileStrategiesOpen ? 'open' : ''}`}>▼</span>
        </div>
          {mobileStrategiesOpen && (
            <div className="mobile-sub-menu">
              <div className="sub-item" onClick={() => { navigate('/opportunities'); setMenuOpen(false); }}>
                Opportunistic Investing
              </div>
              <div className="sub-item" onClick={() => { navigate('/lending'); setMenuOpen(false); }}>
                Direct Lending
              </div>
              <div className="sub-item" onClick={() => { navigate('/liquidity-solutions'); setMenuOpen(false); }}>
                Fund Liquidity Solutions
              </div>
              <div className="sub-item" onClick={() => { navigate('/corporate-finance'); setMenuOpen(false); }}>
                Corporate Financing
              </div>
              <div className="sub-item" onClick={() => { navigate('/estate'); setMenuOpen(false); }}>
                Real Estate
              </div>
            </div>
          )}
        </div>

        {/* Our Team */}
        <div className="mobile-menu-item" onClick={() => { navigate('/team'); setMenuOpen(false); }}>
          Our Team
        </div>

        {/* Careers */}
        <div className="mobile-menu-item" onClick={() => { navigate('/careers'); setMenuOpen(false); }}>
          Careers
        </div>

        {/* Contact Us */}
        <div className="mobile-menu-item no-border" onClick={() => { navigate('/contact-us'); setMenuOpen(false); }}>
          Contact Us
        </div>

      </Nav>
    </div>
  </div>
</div>

      {/**hero section start*/}
      <Container fluid className="px-0" style={{
        marginTop: '6%',
        paddingTop: '80px',
        paddingBottom: '80px',
        backgroundColor: '#CD1C18',
        color: '#ffffff',
        overflow: 'visible', // Allows the image to overlap the bottom edge
        position: 'relative',
        zIndex: 1
    }}>
            <Row  id='sus-row-e' >
            <Col id='sus-col' md = {6} xs={12}>
            <Row id='career-txt-g'><span id='career-bar-g'></span>Real Estate</Row>
            <Row id="ct-g">Kuwait's best Real Estate Investment manager</Row>
          </Col>
          <Col id="border-e" md = {4} style={{ position: 'relative', zIndex: 10, }}>
          <Image

              src={estate}
              style={{
                  width: '85%',
                  height: '610%',
                  objectFit: 'cover',
                  position: 'relative',
                  zIndex: 1, // Image sits below the border lines
                  marginBottom: '-400px', // Pushes image into the next container
                  boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                  display: 'block'
              }}
              alt="Shereen Logo"
          />
      </Col>
            </Row>
       </Container>
       {/**hero section end*/}

       <Container   >
        <Row  >
            <Col id = 'balance-col-est' md = {6} xs={12}>The team works with institutional clients to identify and implement strategies to manage various investment risks.</Col>

        </Row>
       </Container>

       {/**secured */}
       <Container fluid style = {{backgroundColor: '#f8f8f8'}}>
                <Row id='tailored-row-main' >
                    <Row id='tailored-row-e1'>
                      <Col   md = {4} xs={12}    id='fortress-col'>
                        <Row  id='fortress-est'>Shereen Investment’s real estate portfolio is diverse, spanning across various sectors from robust residential communities, commercial and mixed-use properties, to industrial and logistics areas, offering comprehensive solutions to meet the unique requirement of each sector. As one of our largest investment pillars, we aim to contribute to key real estate development projects in the region. In addition to our direct real estate assets, we invest indirectly in international real estate assets and fund structures that have high returns and capital appreciation potential.</Row>
                        <Row  style = {{fontSize: '24px', fontHeight: '36px', fontFamily: 'Lato', marginBottom: '3%', fontWeight: '370', color: '#222b2f'}}><Row    style = {{marginTop: '2%', fontSize: '24px', fontHeight: '36px', fontFamily: 'Lato', fontWeight: '700', color: '#222222'}}>Direct Real Estate</Row><Row id='fortress-est'>As an extension of our experience, we directly invest in strategically located income generating assets and landbanks. Our portfolio comprises various types of properties as well as key developmental projects. This diversity allows us to leverage our wealth of experience for continued growth and success within the evolving dynamic of the real estate sector.</Row></Row>
                      </Col>
                      <Col md = {4} xs={12}    id='fortress-col'>
                        <Row  id='fortress-est'>The company is keen to do the establishment and development of high profile projects, so the company takes the implementation of these projects unique designs to fit a large segment of its customers and always endeavor to provide many of the services in these projects. The company has a variety of housing units in various areas of Kuwait with different sizes. These units are rented to its customer. The company also seeks to provide the best services for tenants and provide them with all means of comfort.</Row>
                        <Row  style = {{fontSize: '24px', fontHeight: '36px', fontFamily: 'Lato', marginBottom: '3%', fontWeight: '370', color: '#222b2f'}}><Row    style = {{marginTop: '1%', fontSize: '24px', fontHeight: '36px', fontFamily: 'Lato', fontWeight: '700', color: '#222222'}}>Indirect Real Estate</Row><Row id='fortress-est'>We invest indirectly in real estate through the best managers in private funds, targeting a diverse range of real estate projects that provide competitive returns through rental yields and capital appreciation. Through this diversification approach, we ensure optimal performance and capital growth. With our diverse approach and diligent selection, we aim to achieve strong and consistent returns over the long term.</Row></Row>
                      </Col>
                    </Row>

                    <Row id='tailored-row-e' xs={12}    style = {{marginTop: '2%'}}>
                        <Row  style = {{fontSize: '24px', fontHeight: '36px', fontFamily: 'Lato', fontWeight: '700', color: '#222222'}}>Real Estate Investments</Row>
                        <Row  id='fortress-est'>Since its inception, Shereen Investment has been an active investor in both the local and international Real Estate markets and has extensive experience in various sectors including resorts, commercial, investment and industrial properties. The company owns and manages real estate in Kuwait, GCC and the Middle East. Shereen Investment Company LLC is primarily involved in property trading, development, direct acquisition and capital improvement in addition to in Local & International Real Estate management in GCC, Europe and the United States and advisory services for its institutional and private clients. The Sector also has a vast experience in providing third party facility management services for individuals, companies, and governmental entities.</Row>
                        <Row  id='fortress-est'>At Shereen Investment, we believe that investment is no longer a luxury but rather a necessity. From this perspective springs our aim of helping clients navigate their financial journey through uniquely diversified investments armed with innovative strategies to build a better future for themselves and generations to come. Our mission is to be alongside our clients in their financial journey from setting their investment goals to achieving financial dreams. Our clients are those who decide to take more control over their financial freedom and well being. They are the ones who go the extra mile to become more financially literate and are able to invest alongside professional investors. Our job is to guide them and provide them with the right investment solutions that match their investment risk.</Row>
                    </Row>

                </Row>
       </Container>





      {/**end reach */}
<Container  fluid className="px-0">
<Row   style = {{marginTop: '1%'}}>
  {/* Card 1: Seeking Capital */}
  <Col lg={6} xs={12}>
      <Card
          className="cta-card"
          style={{
              backgroundColor: '#24325B',
              borderRadius: '0',
              border: 'none',
              height: '100%'
          }}
      >
          <Card.Body className="text-center py-5 px-4 px-md-5">
              <Image src={ab} style={{ height: '32px' }} alt="mail" />

              <h2 style={{
                  fontFamily: 'rufinaalt01',
                  fontWeight: '400',
                  fontSize: 'clamp(28px, 5.5vw, 48px)',
                  lineHeight: '1.15',
                  color: '#ffffff',
                  marginTop: '28px'
              }}>
                  Interested in Seeking Capital
              </h2>

              <p style={{
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  fontSize: 'clamp(18px, 4vw, 24px)',
                  lineHeight: '1.45',
                  color: '#ffffff',
                  maxWidth: '580px',
                  margin: '24px auto 0'
              }}>
                  Contact us to learn how we apply creativity and flexibility to our capital solutions.
              </p>

              <div style={{ marginTop: '45px' }}>
                  <a
                      className="box"
                      href=""
                      onClick={() => navigate('/contact-us')}
                      style={{
                          border: '1px solid #f7f5f0',
                          padding: '18px 24px',
                          display: 'inline-block',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          transition: 'all 0.4s ease'
                      }}
                  >
                      <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                  </a>
              </div>
          </Card.Body>
      </Card>
  </Col>

  {/* Card 2: Join Our Team */}
  <Col lg={6} xs={12}>
      <Card
          className="cta-card"
          style={{
              backgroundColor: '#CD1C18',
              borderRadius: '0',
              border: 'none',
              height: '100%'
          }}
      >
          <Card.Body className="text-center py-5 px-4 px-md-5">
              <Image src={ab} style={{ height: '32px' }} alt="mail" />

              <h2 style={{
                  fontFamily: 'rufinaalt01',
                  fontWeight: '400',
                  fontSize: 'clamp(28px, 5.5vw, 48px)',
                  lineHeight: '1.15',
                  color: '#ffffff',
                  marginTop: '28px'
              }}>
                  Join Our Team
              </h2>

              <p style={{
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  fontSize: 'clamp(18px, 4vw, 24px)',
                  lineHeight: '1.45',
                  color: '#ffffff',
                  maxWidth: '580px',
                  margin: '24px auto 0'
              }}>
                  Strong partnerships with customers start with the right colleagues.
              </p>

              <div style={{ marginTop: '45px' }}>
                  <a
                      className="box"
                      href=""
                      onClick={() => navigate('/careers')}
                      style={{
                          border: '1px solid #f7f5f0',
                          padding: '18px 24px',
                          display: 'inline-block',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          transition: 'all 0.4s ease'
                      }}
                  >
                      <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                  </a>
              </div>
          </Card.Body>
      </Card>
  </Col>
    </Row>
</Container>

            {/**footer section */}
            <Container  fluid style ={{backgroundColor: '#efefef', fontFamily: 'Lato',  paddingBottom: '10px'}}> {/**marginRight: '2%' */}


            <Row id='ft-txt'> © Copyright 2026 Shereen Investment Company LLC</Row>
                                    <Row id= 'last-rw' className='d-md-none m-0 p-0'>
            <Col id='linkd' xs={12} onClick={() => navigate('/')}><FontAwesomeIcon icon={faLinkedin} className="me-2" /></Col>
                  </Row>




    </Container>

            {/*the below div is last div/ function component div*/}
          </div>
    )
}

export default Estate;
